<template>
  <h-frame type="right">
    <div class="unitRight">
      <div class="rightItem">
        <x-title>
          <div class="titleWidth">
            运营时间
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <unitRightOne></unitRightOne>
      </div>
      <div class="rightItem">
        <x-title>
          <div class="titleWidth">
            行业类别
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <unitRightTwo></unitRightTwo>
      </div>
      <div class="rightItem">
        <x-title>
          <div class="titleWidth">
            重点单位
            <!-- <div class="titleMore">更多</div> -->
          </div>
        </x-title>
        <unitRightThree></unitRightThree>
        <!-- <div class="leftpeople">
          <div class="peopleecharts">
            <div class="oneBox">
              <div class="oneItem" v-for="item in obj" :key="item.id">
                <span class="bluecolore">{{ item.name }}:</span>{{ item.value }}
              </div>
              <div class="oneItem">
                <span class="bluecolore">一致:</span>102
              </div>
              <div class="oneItem">
                <span class="bluecolore">不一致:</span>102
              </div>
            </div>
            <div class="oneBluebg">
              <div
                class="bluecount"
                :style="{ width: ((num1 + num2) / 100) * 10 + '%' }"
              >
                {{ num1 }}
              </div>
              :style="{width:(102+10)/100*102}"
              <div class="noBlue">{{ num2 }}</div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </h-frame>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import unitRightOne from "./unitRightOne";
import unitRightTwo from "./unitRightTwo";
import unitRightThree from "./unitRightThree";
import { keyunit } from "@/api/dataAnalysis/unitOfAnalysis.js";
export default defineComponent({
  name: "",
  components: { unitRightOne, unitRightTwo, unitRightThree },
  props: {},
  setup(props) {
    const data = reactive({
      regionId: 0,
      obj: [],
      num1: 0,
      num2: 0
    });
    const refData = toRefs(data);
    // 房屋类别
    const keyunitlist = async () => {
      const res = await keyunit(data.regionId);
      res.data.forEach(v => {
        data.obj.push({ value: v.value, name: v.name });
      });
      data.num1 = data.obj[0].value;
      data.num2 = data.obj[1].value;
      console.log(data.obj, "------------------");
    };
    keyunitlist();
    return {
      ...refData,
      keyunitlist
    };
  }
});
</script>
<style lang="scss" scoped>
.dialog {
  position: absolute;
  position: absolute;
  bottom: 200px;
  right: 360px;
  transition: all 0.5s;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
.unitRight {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 10px;
  color: #fff;
  overflow: auto;

  .titleWidth {
    width: 100%;
  }
  .titleMore {
    float: right;
    cursor: pointer;
    // margin-right: 15px;
    background: #5189b4;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 14px;
  }
  .titleYellow {
    width: 100%;
    text-align: center;
    color: #f3ce61;
    line-height: 40px;
  }
  .rightItem {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    height: 33.3333%;
    font-size: 14px;
    .leftpeople {
      width: 100%;
      height: 100px;
      display: flex;
      flex-direction: column;
      .oneBox {
        display: flex;
        justify-content: space-between;
        line-height: 30px;
        .bluecolore {
          color: #91c8ff;
        }
      }
      .oneBluebg {
        width: 100%;
        height: 30px;
        background: rgba(0, 143, 187, 1);
        border-radius: 4px;
        position: relative;

        .bluecount {
          width: 200px;
          text-align: center;
          height: 100%;
          position: absolute;
          border-radius: 4px;
          box-shadow: 0 0 10px 3px #00c9fa inset;
          background: #00a8ec;
          z-index: 2;
          line-height: 30px;
        }
        .noBlue {
          position: absolute;
          right: 20px;
          line-height: 30px;
        }
      }
    }
  }
}
.event {
  width: 100%;
  display: flex;
  flex-direction: column;
  // margin-bottom: 15px;
  .eventTop {
    display: flex;
    margin: 15px 0;
    justify-content: space-around;
    .topItem {
      display: flex;
    }
    .topLeft {
      width: 58px;
      height: 57px;
      margin-right: 10px;
      text-align: center;
      line-height: 57px;
      background-image: url("~@/assets/images/home/yuan.png");
      background-size: cover;
    }
    .topRight {
      display: flex;
      flex-direction: column;
      .sizeNum {
        font-size: 20px;
        margin-bottom: 5px;
      }
    }
  }
}
.echarts {
  width: 100%;
  height: 180px;
}

.blueColor {
  color: #73f1f3;
}
.moreSelect {
  position: absolute;
  bottom: 24px;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  border-radius: 4px;
  line-height: 28px;
  cursor: pointer;
}
.downBtn {
  padding: 3px 5px;
  background: rgba(0, 0, 0, 0.5);
  // border-radius: 5px;
  position: absolute;
  width: 100%;
  text-align: center;
  cursor: pointer;
}
</style>
